import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";
import { useFormState } from "react-final-form";

const LevelGroupInput = () => {
  const { values } = useFormState();

  return (
    <ReferenceInput
      label="Class"
      source="levelGroupId"
      reference="levelGroups"
      filter={{
        LevelId: values.levelId ? parseInt(values.levelId) : 0,
      }}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default LevelGroupInput;
